import {combineReducers} from 'redux';
import auth from './auth/reducer';
import school from './school/reducer';

export default combineReducers({
    auth, school
});
